import {
  LOAD_SUCCESS_CHAMPS_PERSOS,
  LOAD_FAIL_CHAMPS_PERSOS,
  SAVE_SUCCESS_CHAMPS_PERSOS,
  SAVE_FAIL_CHAMPS_PERSOS,
  UPDATE_SUCCESS_CHAMPS_PERSOS,
  // UPDATE_SUCCESS_ORDRE_CHAMPS_PERSOS,
  UPDATE_FAIL_CHAMPS_PERSOS,
  DELETE_SUCCESS_CHAMPS_PERSOS,
  DELETE_FAIL_CHAMPS_PERSOS,
} from "../actions/champPersoAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_CHAMPS_PERSOS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_CHAMPS_PERSOS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_CHAMPS_PERSOS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_CHAMPS_PERSOS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_CHAMPS_PERSOS:
      const updatedListe = [];
      state.data.forEach((item) => {
        if (item.champ_perso_id === action.payload.champ_perso_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_CHAMPS_PERSOS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_CHAMPS_PERSOS:
      const filtered = state.data.filter((etape) => {
        return etape.champ_perso_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_CHAMPS_PERSOS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
